import { token } from 'brandi';
import { AuthenticationHandler } from '../../domain/contracts/gateways';
import {
  AppointmentRepository,
  DoctorRepository,
  PatientRepository,
  SpecialtyRepository,
  UserRepository
} from '../../domain/contracts/repositories';
import {
  AppointmentService,
  AuthService,
  DoctorService,
  PatientService,
  SessionService,
  SpecialtyService,
  UserService
} from '../../domain/services';

export const TOKENS = {
  // gateways
  authHandler: token<AuthenticationHandler>('AuthenticationHandler'),
  // repositories
  userRepository: token<UserRepository>('UserRepository'),
  appointmentRepository: token<AppointmentRepository>('AppointmentRepository'),
  doctorRepository: token<DoctorRepository>('DoctorRepository'),
  patientRepository: token<PatientRepository>('PatientRepository'),
  specialtyRepository: token<SpecialtyRepository>('SpecialtyRepository'),
  // services
  userService: token<UserService>('UserService'),
  authService: token<AuthService>('AuthService'),
  appointmentService: token<AppointmentService>('AppointmentService'),
  doctorService: token<DoctorService>('DoctorService'),
  patientService: token<PatientService>('PatientService'),
  sessionService: token<SessionService>('SessionService'),
  specialtyService: token<SpecialtyService>('SpecialtyService')
};
